/* eslint-disable prefer-destructuring */

export const API_URL = process.env.API_URL;
export const FRONT_CONNECT = process.env.FRONT_CONNECT;
export const FRONT_PLAYER = process.env.FRONT_PLAYER;
export const EMBED_PLAYER = process.env.EMBED_PLAYER;
export const SENTRY_DSN = process.env.SENTRY_DSN;
export const MEDIAINFO_URL = process.env.MEDIAINFO_URL;
export const ZENDESK_KEY = process.env.ZENDESK_KEY || 'af104ecb-f2a3-4dca-b5e7-884b260c98ad';
